export const oidcSettings = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
